export const FORM_ID = "create-catalog-modal-form";

export const initialValues = {
  name: "",
  description: "",
};
